<script>
  import { onDestroy } from 'svelte';
  import { morseAudioOn } from './stores.js';

  export let playSound = false;
  let isPlaying;

  let context = new AudioContext()
  let o = context.createOscillator()
  if ($morseAudioOn) {
    o.type = "sine"
    o.connect(context.destination)
    o.start();
    o.disconnect();
  }

  // -------------------------------------------------
	$: {
    if (playSound && $morseAudioOn) {
      o.connect(context.destination);
      isPlaying = true;
    } else if (isPlaying && $morseAudioOn) {
      o.disconnect();
      isPlaying = false;
    }
  }
  // -------------------------------------------------

  onDestroy(() => {
    if (isPlaying && $morseAudioOn) {
      o.stop();
    }
		o.disconnect();
	});
</script>
